import once from 'lodash/once';
import { track } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'description_open';


export default once(() => {
  track(EVENT_NAME, { label: 'editor_notes' }, { once: true });
});



// WEBPACK FOOTER //
// ./src/lib/track-event/editor-notes-view.js